import { createSlice } from '@reduxjs/toolkit';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const Grids = {
    REFERRALS: 'referrals',
};

const initGridStates = () =>
    Object.fromEntries(
        Object.values(Grids).map((grid) => [
            grid,
            {
                sort: undefined,
                search: undefined,
                activeFilters: undefined,
                filterPaneWidth: undefined,
            },
        ]),
    );

export const gridsSlice = createSlice({
    name: 'grids',
    initialState: initGridStates(),
    reducers: {
        setGridSort(state, action) {
            const { grid, sort } = action.payload;
            return { ...state, [grid]: { ...state[grid], sort } };
        },
        setGridSearch(state, action) {
            const { grid, search } = action.payload;
            return { ...state, [grid]: { ...state[grid], search } };
        },
        setGridActiveFilters(state, action) {
            const { grid, activeFilters } = action.payload;
            return { ...state, [grid]: { ...state[grid], activeFilters } };
        },
        setFilterPaneWidth(state, action) {
            const { grid, filterPaneWidth } = action.payload;
            return { ...state, [grid]: { ...state[grid], filterPaneWidth } };
        },
    },
});

export const { setGridSort, setGridSearch, setGridActiveFilters, setFilterPaneWidth } =
    gridsSlice.actions;

export const useGridState = (grid, initialSortProperties) => {
    const dispatch = useDispatch();
    const { sort, search, activeFilters, filterPaneWidth } = useSelector(
        (state) => state.grids[grid],
    );
    useEffect(() => {
        if (!sort) {
            dispatch(setGridSort({ grid, sort: initialSortProperties }));
        }
    }, [grid, sort, initialSortProperties, dispatch]);
    return {
        sort,
        search,
        activeFilters,
        filterPaneWidth,
        updateGridSort: (sortProperties) => dispatch(setGridSort({ grid, sort: sortProperties })),
        updateGridSearch: (searchText) => dispatch(setGridSearch({ grid, search: searchText })),
        updateGridActiveFilters: (filters) => {
            // Need to deep compare filter objects to avoid infinite rerender loop when setting initial filters
            // May want to look into limiting re-renders in internal component logic
            if (JSON.stringify(activeFilters) !== JSON.stringify(filters)) {
                dispatch(setGridActiveFilters({ grid, activeFilters: filters }));
            }
        },
        updateFilterPaneWidth: (width) =>
            dispatch(setFilterPaneWidth({ grid, filterPaneWidth: width })),
    };
};
